module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_num"
  }, [_vm._v("Appendix A")]), _vm._v(" "), _c('h2', {
    staticClass: "chap_title"
  }, [_vm._v("The Composition, Dispositions, Command Cadre, and Armored Strength of Mechanized Corps Supporting the Western Front in July 1941")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("5th Mechanized Corps")]), _vm._v(" (Trans-Baikal Military District)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General of Tank Forces Il’ia Prokof’evich Alekseenko.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  13th Tank Division – Colonel Fedor Ustinovich Grachev (killed in action in mid-July 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  17th Tank Division – Colonel Ivan Petrovich Korchagin.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  109th Motorized Division – Colonel Nikolai Ivanovich Sidorenko.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mobilization assignment")]), _vm._v(" – 16th Army, Western TVD.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Actual deployments")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  25 May-26 June 1941 – deployed with 16th Army to Ostrug, Iziaslavl’, and Shepetovka, Kiev Special Military District.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  26-29 June 1941 – deployed with 16th Army to Orsha in the Western Front.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  4 July 1941 – reassigned to the Western Front’s 20th Army.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  5 July 1941 – attacked toward Lepel’ under 20th Army’s control in coordination with 7th Mechanized Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  19 July 1941 – 109th Motorized Division became 109th Rifle Division and, later, 304th Rifle Division.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  10 August 1941 – 13th Tank Division was destroyed and disbanded.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  Late August 1941 – 17th Tank Division was severely damaged in the Smolensk encirclement and converted into 126th Tank Brigade.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 6 July 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  Headquarters – 7 tanks (BT) and 12 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  13th Tank Division – 441 tanks (7 KV, 10 T-34, 238 BT, 112 T-26, 26 KhT, and 48 T-37/38 models) and 97 armored cars. 77 BT-7 and 32 T-26 tanks on 10 July.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  17th Tank Division – 413 tanks (237 BT, 130 T-26, 35 KhT, and 11 T-37/38) and 74 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  109th Motorized Division – 113 tanks (all BT) and 11 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  8th Motorcycle Regiment – 19 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_vm._v("Total")]), _vm._v(" – 974 tanks (7 KV, 10 T-34, 595 BT, 242 T-26, 61 KhT, and 59 T-37/38 models) and 213 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("7th Mechanized Corps")]), _vm._v(" (Moscow Military District)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General Vasilii Ivanovich Vinogradov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  14th Tank Division – Colonel Ivan Dmitrievich Vasil’ev.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  18th Tank Division – Major General of Tank Forces Feodor Timofeevich Rezimov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 1st Motorized Division – Colonel Iakov Grigor’evich Kreizer.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mobilization assignment")]), _vm._v(" – Strategic Reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Actual deployments")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  24 June 1941 – dispatched to Viaz’ma.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  26 June – sent to Smolensk and Orsha under 13th Army’s control.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  26 June – deployed to Orsha under 20th Army’s control.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  28 June – transferred to Rudnia under 20th Army’s control to block the German advance on Smolensk.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 5 July – attacked toward Lepel’ under 20th Army’s control in cooperation with 5th Mechanized Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 6 July 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  14th Tank Division – 293 tanks (24 KV, 29 T-34, 179 BT, 20 T-26, 17 KhT, and 24 T-37/38 models) and 55 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 18th Tank Division – 272 tanks (10 KV, 11 BT, 193 T-26, 54 KhT, and 3 T-37/38 models) and 46 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 9th Motorcycle Regiment – 17 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  251st Separate Signal Battalion – 6 tanks (all BT).")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_vm._v("Total")]), _vm._v(" – 571 tanks (34 KV, 29 T-34, 196 BT, 269 T-26, 71 KhT, and 27 T-37/38 models) and 118 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 1st Motorized Division (operated separately from 7th Mechanized Corps after 5 July) – 229 tanks (205 BT and 24 T-37/38 models) and 39 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("17th Mechanized Corps")]), _vm._v(" (Minsk, Western Front)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General Mikhail Petrovich Petrov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  27th Tank Division – Colonel Aleksei Osipovich Akhmanov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  36th Tank Division – Colonel Sergei Zakharovich Miroshnikov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  209th Motorized Division – Colonel Aleksei Il’ich Murav’ev.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Deployments")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  4 July – ordered to the Bobruisk region with 204th Airborne Brigade and 56th Rifle Division.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 5 July – subordinated to 21st Army.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  Late July – withdrawn to the Sukhinichi region under 4th Army and incorporated into 27th Tank Division.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 1 August – converted into 147th Tank Brigade.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 7 July 1941")]), _vm._v(" – no armored vehicles.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("20th Mechanized Corps")]), _vm._v(" (Baranovichi, Western Front)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General Andrei Grigor’evich Nikitin, Major General of Tank Forces Nikolai Denisovich Vedeneev on 21 July 1941.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  26th Tank Division – Major General Viktor Timofeevich Obukhov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  38th Tank Division – Colonel Sergei Ivanovich Kapustin.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  210th Motorized Division.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Deployments")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  22-27 June – fought in the vicinity of Minsk.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  9-27 July – fought and destroyed in the Mogilev encirclement, with 100-200 men escaping on 27-28 July.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 7 July 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  26th Tank Division – 3,000 men and 3 152mm howitzers.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  38th Tank Division – 3,800 men and 5 guns.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  210th Motorized Division – 5,000 men and 9 guns.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_vm._v("Total")]), _vm._v(" – 12,000 men and 27 guns, but no tanks.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("23rd Mechanized Corps")]), _vm._v(" (Orel Military District)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General Mikhail Akimovich Miasnikov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  48th Tank Division – Colonel Dmitrii Iakovlevich Iakovlev.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  51st Tank Division – Colonel Grigorii Georgievich Chernov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  220th Motorized Division – Major General Nikifor Gordeevich Khoruzhenko.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mobilization assignment")]), _vm._v(" – Strategic Reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Actual deployments")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  27 June 1941 – assigned to 24th Army, which was deploying westward from the Siberian Military District.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  1 July – assigned to the Western Front’s 19th Army to replace 25th Mechanized Corps and deployed to Vitebsk and Liozno region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  10 July – 51st Tank Division was assigned to 31st Army, but its replacement, 57th Tank Division, never arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  11 July – dispatched to the Mogil’no and Berezino region in 19th Army’s reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 29 June 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  48th Tank Division – 104 tanks (3-T-34 and 101 T-26 models).")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  57th Tank Division – unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  220th Motorized Division – unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_vm._v("Total")]), _vm._v(" – 413 tanks (21 KVs and T-34 models).")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("25th Mechanized Corps")]), _vm._v(" ( Khar’kov Military District)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General Semen Moiseevich Krivoshein.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  50th Tank Division – Colonel Boris Sergeevich Bakharov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  55th Tank Division – Colonel Vasilii Mikhailovich Badanov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  219th Motorized Division – Major General Pavel Petrovich Korzun.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mobilization assignment")]), _vm._v(" – Strategic Reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Actual deployments")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  24-29 June 1941 – deployed by rail to the Kiev region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  30 June – assigned to 19th Army in Kiev region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  3-8 July – transferred by rail to the Novozybkov region under 21st Army’s control.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  13 July – prepared to counterattack toward Bykhov and Bobruisk with 21st Army.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 1 July 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  50th Tank Division – Unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  55th Tank Division – Unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_vm._v("Total")]), _vm._v(" – 163 tanks (6 BTs and 157 T-26 models), reinforced by 64 T-34 tanks by 13 July.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("26th Mechanized Corps")]), _vm._v(" (North Caucasus Military District)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General Nikolai Iakovlevich Kirichenko.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  52nd Tank Division – Colonel Grigorii Mikhailovich Mikhailov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  56th Tank Division – Colonel Ivan Dmitrievich Illarionov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  103rd Motorized Division – Major General Grigorii Timofeevich Timofeev, Lieutenant Colonel V. P Sokolov on 22 July, and Major General Ivan Ivanovich Birichev on 11 August.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mobilization assignment")]), _vm._v(" – Strategic Reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Actual deployments")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  28-29 June – dispatched to the Kiev region with 19th Army, but diverted to 24th Army on 13 July.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 8-16 July – disbanded, with 52nd and 56th Tank Divisions converted to 101st and 102nd Tank Divisions and 103rd Motorized Division to 103rd Tank Division, all in 24th Army’s reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 7 July")]), _vm._v(" – unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("27th Mechanized Corps")]), _vm._v(" (Central Asian Military District)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Major General Ivan Efimovich Petrov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Composition")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  9th Tank Division – Colonel Vasilii Gerasimovich Burkov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  53rd Tank Division – Colonel Aleksei Stepanovich Beloglazov.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  221st Motorized Division – Colonel Gersh Moiseevich Roitenberg.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mobilization assignment")]), _vm._v(" – Strategic Reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Actual deployments")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  25 June – received alert order for deployment to the West beginning on 4 July.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  27 June – began rail movement to Voronezh.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  10 July – assigned to 28th Army and began moving to the Kirov region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  11-15 July – disbanded, with 9th Tank Division converted into 104th Tank Division, 53rd Tank Division into 105th Tank Division, and 221st Motorized Division into 106th Tank Division. All were located in the Spas-Demensk region subordinate to 28th Army.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 19 July – 106th Tank Division was renamed 106th Motorized Division and moved to the Smolensk region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Strength on 15 July 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v("  104th Tank Division – 208 tanks (50 BT-7, 19 BT-5, 3 BT-2, and 136 T-26 models) and 51 armored cars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" 53rd Tank Division – unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet2"
  }, [_c('span', {
    staticClass: "bull2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull1.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_vm._v("Total")]), _vm._v(" – unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Note")]), _vm._v(": KhT means chemical ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("khimicheskii]")]), _vm._v(" tanks equipped with flamethrowers or smoke generators.")]), _vm._v(" "), _c('p', {
    staticClass: "hangings"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sources")]), _vm._v(": Evgenii Drig, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mekhanizirovnnye korpusa RKKA v boiu: Istorii avtobronetankovykh voisk Krasnoi Armii v 1940-1941 godakh")]), _vm._v(" [The RKKA’s Mechanized Corps in Battle: A history of the auto-armored forces of the Red Army in 1940-1941] (Moscow: Transkniga, 2005); and Il’ia Moshchansky and Ivan Khokhlov, “Protivostoianie: Smolenskoe srazhenie, 10 iiulia-10 sentiabria 1941 goda, chast’ 1” [Confrontation: the Battle of Smolensk, 10 July-10 September 1941, part 1], in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Voennaia letopis’")]), _vm._v(" [Military chronicle], 3, 2003, 4-7.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b79e3c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter_1.vue
// module id = 90
// module chunks = 0